import { useSelector } from 'react-redux';

import * as scenarioGridSelectors from '@makemydeal/dr-dash-store/selectors/scenarioGridSelectors';
import type { ScenarioGridRowKey } from '@makemydeal/dr-dash-store/types/scenarioGridTypes';

import {
    OUTSIDE_LIENHOLDER_SUB_ROW_KEYS,
    useOutsideLienholderExpansion
} from '../rows/fields/OutsideLienholderRow/OutsideLienholderExpansion';

export const ROWS_WITHOUT_HOVER_HIGHLIGHT: readonly string[] = ['paymentGrid'];

export const useScenarioGridRows = () => {
    const rowKeys = useSelector(scenarioGridSelectors.getScenarioRowKeys);
    const { isExpanded: isLienholderExpanded } = useOutsideLienholderExpansion();

    const expandedSubRowKeys: Partial<Record<ScenarioGridRowKey, readonly string[]>> = {
        outsideLienholder: isLienholderExpanded ? OUTSIDE_LIENHOLDER_SUB_ROW_KEYS : []
    };

    const gridRowKeys = rowKeys.flatMap((rowKey) => [rowKey, ...(expandedSubRowKeys[rowKey] ?? [])]);
    const hoverRowKeys = gridRowKeys.filter((rowKey) => !ROWS_WITHOUT_HOVER_HIGHLIGHT.includes(rowKey));

    return { gridRowKeys, hoverRowKeys };
};
